module.exports = __webpack_public_path__ + "static/img/s31.2110466a.png";